import { render } from "./SongResourcesTab.vue?vue&type=template&id=42153c27"
import script from "./SongResourcesTab.vue?vue&type=script&lang=js"
export * from "./SongResourcesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__